import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import type {
  EventDetail,
  EventRegisterRequest,
  EventSummary,
  PageOf,
  RegistrationResponse,
} from '@/lib/api/models';
import { unwrap } from '@/lib/api/request';

export function useEvents(params: { limit?: number; offset?: number } = {}) {
  const { limit = 12, offset = 0 } = params;
  return useQuery<PageOf<EventSummary>>({
    queryKey: ['events', { limit, offset }],
    queryFn: () => unwrap(api.GET('/events', { params: { query: { limit, offset } } })),
  });
}

export function useEvent(eventId: string) {
  return useQuery<EventDetail>({
    queryKey: ['event', eventId],
    queryFn: () => unwrap(api.GET('/events/{event_id}', { params: { path: { event_id: eventId } } })),
  });
}

export function useRegisterForEvent(eventId: string) {
  const queryClient = useQueryClient();
  return useMutation<RegistrationResponse, unknown, EventRegisterRequest>({
    mutationFn: (body) =>
      unwrap(
        api.POST('/events/{event_id}/register', {
          params: { path: { event_id: eventId } },
          body,
        }),
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['event', eventId] }),
  });
}
